/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: organization_role.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  ListOrganizationRolesRequest,
  ListOrganizationRolesResponse,
} from '../types/organization_role';

export const createOrganizationRoleService = (transport: Transport) => ({
  async listOrganizationRoles(
    request: ListOrganizationRolesRequest,
    options: RequestOptions = {},
  ): Promise<ListOrganizationRolesResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.OrganizationRoleService.ListOrganizationRoles, {
      organization_id,
    });
    return transport.get<ListOrganizationRolesResponse>(url, { params, ...options });
  },
});

export type OrganizationRoleService = ReturnType<typeof createOrganizationRoleService>;
